import { render } from "./PeriodInfoPage.vue?vue&type=template&id=9052f9ce"
import script from "./PeriodInfoPage.vue?vue&type=script&lang=js"
export * from "./PeriodInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__